import React from 'react';
import { CfQueues } from './cf-queues';
import { CfWorkers } from './cf-workers';
import { CfR2 } from './cf-r2';

function CfInfrastructure({ tab }) {
    if (tab === 'queues') return <CfQueues />;
    if (tab === 'workers') return <CfWorkers />;
    if (tab === 'r2') return <CfR2 />;
    return null;
}

export { CfInfrastructure };
